import { createStyles, makeStyles } from "@material-ui/core";
const FTLButtonStyle = makeStyles((theme) => createStyles({
    root: {
        padding: "4px 12px",
        minHeight: 32,
        minWidth: 32,
        boxShadow: "none",
        textTransform: "none",
        "&:hover, &:active": {
            boxShadow: "none !important",
        },
    },
    buttonContentWrapper: {
        fontFamily: "inherit",
        width: "inherit",
        display: "inherit",
        alignItems: "inherit",
        justifyContent: "inherit",
    },
    dots: {
        position: "absolute",
        margin: "auto",
    },
    primary: {
        backgroundColor: theme.palette.button.primaryEnabled,
        "&:hover": {
            backgroundColor: theme.palette.button.primaryHover,
        },
        "&:active": {
            backgroundColor: theme.palette.button.primaryPressed,
        },
        "& $label": {
            fontWeight: 600,
        },
    },
    label: Object.assign(Object.assign({}, theme.typography.buttonTextSecondary), { fontSize: "14px", lineHeight: "20px", letterSpacing: "-0.09px", "& .MuiButton-iconSizeMedium > :first-child": {
            fontSize: 12,
        } }),
    large: {
        minHeight: "40px",
        padding: "10px 22px",
    },
    small: {
        padding: 4,
    },
    focus: {
        boxShadow: `0 0 0 2px ${theme.palette.border.focus} !important`,
    },
    selected: {
        backgroundColor: `${theme.palette.button.secondarySelected} !important`,
        "& $label": {
            color: `${theme.palette.text.onColor} !important`,
        },
        "&.Mui-disabled": {
            "& $label": {
                color: `${theme.palette.text.onColor} !important`,
            },
            backgroundColor: `${theme.palette.button.secondarySelected} !important`,
        },
    },
    secondary: {
        backgroundColor: theme.palette.button.secondaryEnabled,
        "& $label": {
            color: theme.palette.text.secondary,
        },
        "&:hover": {
            backgroundColor: theme.palette.button.secondaryHover,
        },
        "&:active": {
            backgroundColor: theme.palette.button.secondaryPressed,
            "& $label,  & $label svg": {
                color: `${theme.palette.text.onColor}`,
            },
        },
    },
    disabled: {
        backgroundColor: `${theme.palette.button.disabled} !important`,
        "& $label": {
            color: theme.palette.text.disabled,
        },
    },
    textPrimary: {},
    textSecondary: {
    // ...theme.typography.buttonTextSecondary,
    },
    tertiary: {
        color: theme.palette.text.tertiary,
        "&:hover": { backgroundColor: theme.palette.button.tertiaryHover },
        "&:active": {
            backgroundColor: theme.palette.button.tertiaryPressed,
            "& $label,  & $label svg": {
                color: `${theme.palette.text.onColor} !important`,
            },
        },
    },
}));
export default FTLButtonStyle;
//# sourceMappingURL=FTLButtonStyle.js.map